export const app_mode = window.acclConfigs.VUE_APP_MODE || 'bulk';
export const api_mode = window.acclConfigs.VUE_APP_API_INTEGRATION_MODE || "actual"

export const action = {
    DELETE: "Delete",
    REPLACE: "Replace",
    REMOVE_CALC_ROW:"removeCalcRow"
};

export const actionLabel = {
    COMPARE: "Compare"
}

export const user = {
    id: "userId",
    name: "userName",
    source: "source",
    role: "role",
};

export const role = {
    user: "user",
    admin: "admin",
    superadmin: "superadmin"
};

export const type = {
    XSL: "xsl",
    XML: "xml",
    PROJECT: "project",
    SCHEMA: "schema",
    KAFKA: "jms",
    CONNECTOR: "connector",
    MAPPER: "mapper",
    USER_ROLES: "users",
    DOWNLOADS: "downloads",
    DOWNLOAD_URL: "download_url",
    MAPPER_USAGE:"mapper.usage",
    MAPPER_TRANSITION:"mapper.transition",
    MAPPER_ACTIVITIES:"mapper.activities",
    MAPPER_MAPPING:"mapper.mapping",
    MAPPER_COMPLEXITY:"mapper.complexity",
    MAPPER_COMPONENT:"mapper.component",
    API: "api",
    MAPPER_ACTIVITY:"mapper.Usage_Activities",
    MAPPER_PROCESS_DETAILS:"mapper.Process_Details",
    MAPPER_MAPPING_REFERENCES: "mapper.Mapping_References",
    MAPPER_MAPPING_JOBS: "mapper.MAPPER_MAPPING_JOBS",
    CHILD_ACTIVITY: "mapper.Child_Activities",
    CHILD_ACTIVITY_VIEW: "mapper.View_Child_popup",   
    ORCHESTRATION: "orchestration",
};
export const pageViews = {
    TRASHVIEW : "TrashView",
    FILEDIFFERENCE : "FileDifferenceNew",
    XSL_FILE_DIFF : "XSLFileDifferenceView",
    XML_FILE_DIFFERENCE : "XMLFileDifferenceNew",
    XMLTRANSFORM: "XmlTransformView",
    LOGINVIEW: "LoginView",
    CONVERTERVIEW: "ConverterView",
    HEADERVIEW: "HeaderView",
    CALLBACKVIEW : "CallBackView",
    CANVASVIEW:"CanvasView",
    INDEPENDENT_ACC_VIEW: "IndependentAcceleratorsView",
    ALLINONE_ACC_VIEW: "AllInOneAcceleratorsView",
    VIEW_404: "UnderConstructionView",
    SCHEMACONVERTERVIEW: "SchemaConverterView",
    KAFKACONFIGGENERATORVIEW: "KafkaConfigGeneratorView",
    CONNECTOR_CONFIG_GENERATOR_VIEW: "ConnectorConfigGeneratorView",
    MANAGE_USERS_VIEW: "ManageUsersView",
    DOWNLOADS_VIEW: "DownloadsView",
    ERROR_VIEW: "ErrorPageView",
    FLOATING_COMPONENT: "FloatingComponent",
    MAPPERVIEW: "MapperView",
    TAB_CONTENT_VIEW: "TabContentView",
    USAGEVIEW: "UsageView",
    TRANSITIONVIEW:"TransitionView",
    ACTIVITYTYPESVIEW:"ActivityTypesView",
    FIELDMAPPINGVIEW:"FieldMappingView",
    COMPONENTVIEW:"ComponentView",
    APIVIEW: "ApiView",
    FOOTERVIEW: "FooterView",
    ACTIVITIES_VIEW: "ActivitiesView",
    PROCESS_DETAILS_VIEW: "ProcessDetailsView",
    MAPPING_REFERENCES_VIEW: "MappingReferencesView",
    MAPPING_JOBS_VIEW: "MappingJobsView",
    CHILD_ACTIVITIES_VIEW: "ChildActivities",
    VIEW_CHILD_ACTIVITIES_POPUP: "ViewChildActivities",
    ORCHESTRATION_VIEW: "OrchestrationView",
}

export const elementsToRemoveFromArray = ["actions", "*"];

export const invalidBEColumns = {
    [type.XSL]: ["actions", "*"],
    [type.XML]: ["*"],
    [type.SCHEMA]: ["*"],
    [type.PROJECT]: ["accelatorStatus","*"],
    [type.KAFKA]: ["*"],
    [type.USER_ROLES]: ["*"],
    [type.DOWNLOADS]: ["*"],
    [type.CONNECTOR]: ["*"],
    [type.MAPPER]: ["*"],
    [type.API]: ["*"],
    [type.ORCHESTRATION]: ["*"],
}
/**
 * Hard code requestId, as it is required for the report action
 * Hard code convertedCount & tibcoCount, as it is required for the accuracy calculation
 */
export const supportingColumns = {
    [type.XSL]: [
        "projectId",
        "xslId",
        "convertedCount",
        "tibcoCount",
        "status"
    ],
    [type.API]: [
        "projectId",
        "apiId"
    ],
    [type.KAFKA]: [
        "projectId",
        "jmsId"
    ],
    [type.XML]: [
        "xmlId"
    ],
    [type.SCHEMA]: [
        "projectId",
        "xsdId",
    ],
    [type.PROJECT]: [
        "projectId",
        "xslAccuracy",
        "jmsAccuracy",
        "schemaAccuracy",
        "connectorAccuracy",
        "mapperAccuracy",
        "mapperStatus",
        "connectorStatus",
        "jmsStatus",
        "schemaStatus",
        "xslStatus",
        "accelatorStatus",
        "apiStatus",
        "apiAccuracy",
    ],
     [type.CONNECTOR]: [
        "projectId",
        "cfgId",
    ],
    [type.MAPPER]: [
        "projectId",
        "mapperId",
    ],
    [type.USER_ROLES]: [

    ],
    [type.DOWNLOADS]: [
        "downloadId",
        "projectId",
        "type",
        "binaryName",
        "fileName",
        "status",
        "remarks",
        "creaTs",
        "procTs"
    ],
    [type.ORCHESTRATION]: [
        "projectId",
        "orchestrationId",
        "status"
    ],
}

export const CONVERSION_STATUS = {

    OK : { value : 'ok' , name : "Success" },
    PROGRESS : { value : 'in-prog', name : "In Progress" },
    FAIL : { value : 'fail', name : "Failed" },
    NEW : { value : 'new', name : "New" },
    NA: { value: 'NA', name: "Not Applicable"},
    TRUE: {value: 'true', name: "In-Active"},
    FALSE: {value: 'false', name: "Active"},

    getByValue: function(value) {
        let valueInLower = value.toString();
        for (let key in this) {
            if (this[key].value && this[key].value === valueInLower) {
                return this[key];
            }
        }
        throw new Error(`No enum constant with value ${value}`);
    },
    getByName: function(name) {
        for (let key in this) {
            if (this[key].name && this[key].name === name) {
                return this[key];
            }
        }
        throw new Error(`No enum constant with value ${name}`);
    }

}

export const STATUS_COLUMNS = [
    'status',
    'xslStatus',
    'schemaStatus',
    'jmsStatus',
    'connectorStatus',
    'mapperStatus',
    'isDisabled',
    'acceleratorStatus',
    'apiStatus',
    'orchestrationStatus',
    
]

export const ACCURACY_COLUMNS_STATUS_MAP = {
    status: 'accuracy',
    xslStatus: 'xslAccuracy', 
    schemaStatus: 'schemaAccuracy',
    jmsStatus: 'jmsAccuracy',
    connectorStatus: 'connectorAccuracy',
    mapperStatus: 'mapperAccuracy',
    acceleratorStatus: 'acceleratorAccuracy',
    apiStatus: 'apiAccuracy',
    orchestrationStatus: 'orchestrationAccuracy',
}

export const DATE_COLUMNS = [
    'requestDate',
    'lastModifiedDate',
    'lastLoginTime',
]

export const GRID_ACTION_DATA_ELEMENTS = {
    [type.PROJECT] : {
        'fileNameKey': "fileName",
        'requestIdKey': "projectId",
        'projectIdKey': "projectId",
    },
    [type.XSL] : {
        'fileNameKey': "xslFileName",
        'requestIdKey': "xslId",
        'projectIdKey': "projectId",
    },
    [type.SCHEMA] : {
        'fileNameKey': "xsdName",
        'requestIdKey': "xsdId",
        'projectIdKey': "projectId",
    },
    [type.KAFKA] : {
        'fileNameKey': "fileName",
        'requestIdKey': "jmsId",
        'projectIdKey': "projectId",
    },
    [type.API] : {
        'fileNameKey': "fileName",
        'requestIdKey': "apiId",
    },
    [type.XML] : {
        'fileNameKey': "xmlFileName",
        'requestIdKey': "xmlId",
        'projectIdKey': "projectId",
    },
    [type.USER_ROLES] : {
        'requestIdKey': "userId",
        'projectIdKey': "projectId",
    },
    [type.DOWNLOADS] : {
        'fileNameKey': "file_name",
        'requestIdKey': "downloadId",
        'projectIdKey': "project_id",
    },
    [type.CONNECTOR] : {
        'fileNameKey': "fileName",
        'requestIdKey': "cfgId",
        'projectIdKey': "projectId",
    },
    [type.MAPPER] : {
        'fileNameKey': "mapperFileName",
        'requestIdKey': "projectId",
        'projectIdKey': "projectId",
    },
    [type.ORCHESTRATION] : {
        'fileNameKey': "usecaseNames",
        'requestIdKey': "orchestrationId",
        'projectIdKey': "projectId",
    },

}

export const ROUTER_PARAMS_GRID_FILTER_MAP = {
    [type.PROJECT] : {
        'projectParamId' : "projectId",
    },
    [type.XSL] : {
        'projectParamId' : "projectId",
        'xslParamId' : "xslId"
    },
    [type.SCHEMA] : {
        'projectParamId' : "projectId",
        'xsdParamId' : "xsdId"
    },
    [type.KAFKA] : {
        'projectParamId' : "projectId",
        'jmsParamId' : "jmsId"
    },
    [type.API] : {
        'projectParamId' : "projectId",
        'apiParamId' : "apiId"
    },
    [type.XML] : {
        'xslParamId' : "xslId",
        'xmlParamId' : "xmlId"
    },
    [type.CONNECTOR] : {
        'projectParamId' : "projectId",
        'configParamId' : "cfgId"
    },
    [type.MAPPER] : {
        'projectParamId' : "projectId",
        'mapperParamId' : "mapperId"
   },
    [type.ORCHESTRATION] : {
        'projectParamId' : "projectId",
        'orchestrationParamId' : "orchestrationId"
   },
    
}

export const ROUTER_PARAMS_VIEW_MAP = {
    [type.PROJECT] : {
        'projectParamId' : "projectId",
    },
    [type.XSL] : {
        'projectParamId' : "projectId",
        'xslParamId' : "requestId"
    },
    [type.SCHEMA] : {
        'projectParamId' : "projectId",
        'xsdParamId' : "requestId"
    },
    [type.KAFKA] : {
        'projectParamId' : "projectId",
        'jmsParamId' : "requestId"
    },
    [type.XML] : {
        'projectParamId' : "projectId",
        'xslParamId' : "xslId",
        'xmlParamId' : "requestId"
    },
    [type.API] : {
        'projectParamId' : "projectId",
        'apiParamId' : "requestId"
    },
    [type.ORCHESTRATION]: {
        'projectParamId' : "projectId",
        'orchestrationParamId' : "requestId"
    },
}

export const EDITABLE_GRID_CHANGES_COLUMNS = {
    [type.USER_ROLES]: {
        "userName": "User Name",
        "role": "Role",
        "isDisabled": "State"
    },
}

export const EDITABLE_GRID_ACTIONS = {
    [type.USER_ROLES]: {
        inquiryEndpoint: "/search",
        ingestionEndpoint: "/updateuser",
    }
}

export function changeFileExtension(fileName, newExtension) {
    const lastDotIndex = fileName.lastIndexOf(".");
    if (lastDotIndex !== -1) {
      return fileName.substring(0, lastDotIndex) + "." + newExtension;
    }
    return fileName + "." + newExtension;
  }

/**
 * Formats a date consistently as MM/DD/YYYY across all platforms
 * Detects platform from user agent and normalizes date format
 * @param {Date|string} dateValue - The date value to format
 * @returns {string} - Formatted date string in MM/DD/YYYY format
 */
export function formatDateConsistent(dateValue) {
    if (!dateValue || dateValue === null ) return "-";
    const date = new Date(dateValue);
    if (isNaN(date.getTime())) return dateValue;
    
    // Always format as MM/DD/YYYY regardless of platform/locale
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');
    const year = date.getFullYear();
    return `${month}/${day}/${year}`;
}